import { useEffect, useState } from "react";
import { Modal, Snackbar } from "@talladega/components";
import classNames from "classnames";
import { useTranslation } from "next-i18next";
import {
  BaseVehicleDetail,
  VehicleDetail,
} from "@modules/vehicle/types/VehicleDetail";
import { GetBackgroundStyle } from "@talladega/helpers";
import { ActionButton, GravityFormSide } from "@talladega/types";
import GravityForm from "./GravityForm";

type FormProps = GravityFormSide;

export type ButtonModalState = {
  show: boolean;
  actionType: ActionButton;
  gubagooEventId?: number;
  formProps?: FormProps;
};

type Props = {
  buttonModalState: ButtonModalState;
  vehicle?: VehicleDetail | BaseVehicleDetail;
};

const CmsButtonModalContainer = ({ buttonModalState, vehicle }: Props) => {
  const { t } = useTranslation(["common"]);
  const [buttonModalComponent, setButtonModalComponent] =
    useState<JSX.Element | null>(null);

  const baseDomain = process.env.NEXT_PUBLIC_CLOUDFLARE_IMAGES_DOMAIN || "";

  useEffect(() => {
    switch (buttonModalState.actionType) {
      case ActionButton.GravityForm: {
        if (!buttonModalState.formProps?.gravityForm.form) {
          break;
        }

        const {
          gravityForm: { form, id: gravityFormsId, campaignTag, background },
          heading,
          subheading,
        } = buttonModalState.formProps;

        setButtonModalComponent(
          <Modal
            alignment="center"
            isOpen={buttonModalState.show}
            onClose={() => setButtonModalComponent(null)}
          >
            <div
              className="w-full rounded-lg p-8"
              style={GetBackgroundStyle(background, baseDomain)}
            >
              {heading?.isActive && (
                <div className="p-4 text-center">
                  <h3
                    className={classNames("leading-snug text-primary-deep", {
                      "mb-4": subheading.isActive,
                    })}
                  >
                    {heading.label ?? form.title}
                  </h3>
                  <p className="text-base text-gray-500">
                    {subheading?.isActive ? subheading.label : form.description}
                  </p>
                </div>
              )}
              <div className="w-full space-y-3 text-center">
                <GravityForm
                  form={form}
                  formId={gravityFormsId}
                  heading={null}
                  subheading={null}
                  campaignTag={campaignTag}
                  submitButtonText={form.submitButton?.text}
                  isPopup
                  onSubmit={() => {
                    Snackbar.Pop({
                      message:
                        form.confirmations?.[0]?.message ||
                        t("common:thanks_for_applying"),
                    });
                    setButtonModalComponent(null);
                  }}
                  onError={() => {
                    Snackbar.Pop({
                      message: t("common:something_went_wrong"),
                    });
                  }}
                  vehicle={vehicle}
                />
              </div>
            </div>
          </Modal>
        );
        break;
      }
      default:
        break;
    }
    // Disable dep warning as vehicle causes infinite render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonModalState, t]);

  return (
    <div>
      {buttonModalComponent && buttonModalState.show && (
        <div> {buttonModalComponent} </div>
      )}
    </div>
  );
};

export default CmsButtonModalContainer;
